import { render, staticRenderFns } from "./CarouselHome.vue?vue&type=template&id=8274b890&scoped=true"
import script from "./CarouselHome.vue?vue&type=script&lang=js"
export * from "./CarouselHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8274b890",
  null
  
)

export default component.exports